// extracted by mini-css-extract-plugin
module.exports = {"icon":"AssetsView_icon__1AnC_","label":"AssetsView_label__12TDC"};